export default __webpack_public_path__ + "static/media/871.f39b81ad.png";